module.exports = __webpack_public_path__ + "static/media/img-placeholder.cc561d21.svg";